import axios from "axios";
import {
    INSTALLER_URL,
    INSTALLER_URL_PORTAL,
    INSTALLER_URL_PORTAL2,
} from "../../API/Api";

const getAllInstaller = async (token) => {
    const headers = {
        // Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL2}`,
        headers: headers,
    });
    return response.data;
};

const installerSearch = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "GET",
        headers,
        baseURL: `${INSTALLER_URL}/search`,
        params: data,
    });
    return response.data;
};

const RegisterFormInstaller = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/register`,
        data: data,
    });
    return response.data;
};

const BussinessLicenceInstaller = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/license/create`,
        data: data,
    });
    return response.data;
};
const BussinessLicenceInstallerUpdate = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/license/update/${data.license_id}`,
        data: data.data,
    });
    return response.data;
};

const WorkingDaysInstaller = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/working-days`,
        data: data,
    });
    return response.data;
};

const UpdateInstaller = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/update/${data.installer_id}`,
        data: data.data,
    });
    return response.data;
};
const AdderRateInstaller = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "POST",
        headers,
        baseURL: `${INSTALLER_URL_PORTAL2}/aders-store`,
        data: data,
    });
    return response.data;
};

const GetInstallerDocs = async (installer_id) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL}/docs/${installer_id}`,
        headers: headers,
    });
    return response.data;
};

const GetInstallerAdders = async (installer_id) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL}/adders/${installer_id}`,
        headers: headers,
    });
    return response.data;
};

const GetInstallerLicense = async (installer_id) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL}/license/${installer_id}`,
        headers: headers,
    });
    return response.data;
};

const InstallerLicenseCreate = async (data) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "POST",
        baseURL: `${INSTALLER_URL_PORTAL2}/license/create`,
        headers: headers,
        data: data,
    });
    return response.data;
};

const InstallerLicenseEdit = async (data) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "POST",
        baseURL: `${INSTALLER_URL_PORTAL2}/license/update`,
        headers: headers,
        data: data,
    });
    return response.data;
};

const GetSingleInstaller = async (installer_id) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL2}/${installer_id}`,
        headers: headers,
    });
    return response.data;
};

const GetSingleInstallerLicense = async (license_id) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${INSTALLER_URL_PORTAL2}/license/single/${license_id}`,
        headers: headers,
    });
    return response.data;
};

const DeleteSingleInstaller = async (license_id) => {
    let headers = {
        token: `bL4r$a$c$e6JA8cU`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "DELETE",
        baseURL: `${INSTALLER_URL_PORTAL2}/destroy/${license_id}`,
        headers: headers,
    });
    return response.data;
};
const installerService = {
    getAllInstaller,
    installerSearch,
    RegisterFormInstaller,
    BussinessLicenceInstaller,
    BussinessLicenceInstallerUpdate,
    WorkingDaysInstaller,
    AdderRateInstaller,
    GetInstallerDocs,
    GetInstallerAdders,
    GetInstallerLicense,
    InstallerLicenseCreate,
    InstallerLicenseEdit,
    GetSingleInstaller,
    GetSingleInstallerLicense,
    UpdateInstaller,
    DeleteSingleInstaller,
};

export default installerService;
